<template>
  <div>
    <el-dialog
      :title="title"
      :show="localVisible"
      width="70%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="formData" label-width="100px">
        <el-divider content-position="left">基本信息</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="所属商户">
              <el-select
                v-model="form.pos_member_id"
                filterable
                style="width: 180px;"
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="memberRemoteMethod"
                :loading="memberLoading">
                <el-option
                  v-for="item in memberList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属代理商">
              <el-input width="400" placeholder="请输入所属代理商"  :disabled="true" v-model="form.proxy_name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属渠道" >
              <el-input width="400" placeholder="请输入所属渠道" :disabled="true" v-model="form.company_user_real_name" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="门店类型" size="small">
              <el-select
                v-model="form.type" clearable
                placeholder="请选择状态"
              >
                <el-option label="分店" :value="2"></el-option>
                <el-option label="总店" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="门店名称">
              <el-input width="400" required placeholder="请输入门店名称"  v-model="form.name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" size="small">
              <el-select
                v-model="form.status" clearable
                placeholder="请选择状态"
              >
                <el-option label="开启" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">联系信息</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="所属区域">
              <el-cascader
                ref="cascaderAddr"
                style="width: 90%"
                v-model="areaList"
                :props="propsdata"
                :key="isResouceone"
                @change="handleChangeAddress"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址">
              <el-input width="400" required placeholder="请输入详细地址"  v-model="form.address" type="text"></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="8">-->
<!--            <el-form-item label="经纬度">-->
<!--              <el-input width="400" required placeholder="请输入经纬度"  v-model="lng_lat" type="text"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="联系人姓名">
              <el-input width="400" required placeholder="请输入联系人姓名"  v-model="form.cont_name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人手机">
              <el-input width="400" required placeholder="请输入联系人手机"  v-model="form.mobile" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="终端产品" size="small">
              <el-select
                v-model="form.pos_brand_id" clearable
                placeholder="请选择状态"
              >
                <el-option v-for="(item,index) in posBrandList" :key="index" :label="item.name" :value="item.id"></el-option>

              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    name:'eEmployee',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data() {
      return {
        form:{
          pos_member_id:'',
          proxy_name:'',
          company_user_real_name:'',
          address:'',
          pos_brand_id:'',
          mobile:'',
          cont_name:'',
          name:'',
          type:'',
          status:''
        },
        localVisible:false,
        posBrandList:[],
        memberLoading:'',
        memberList:[],
        memberStates:[],

        lng_lat:'',

        areaList: [],

        rules: {

        },
        curShop: '',
        employee_id: '',
        name_cn: '',

        keywords: '',
        fileList: [],
        mList: [],
        pageNum: 1,
        pageSize: 10,
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          lazy: true,
          lazyLoad(node, resolve) {
           // const {level} = node;
            console.log(node)
            let url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
               // var _this = this;

                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: 1
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function () {
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function () {
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                }).catch(function () {
                });
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
      this.getPosBrandList();
      ///this.getList();
    },
    methods:{
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.formData.province_id=checkedNode[0].path[0];
        _this.formData.city_id=checkedNode[0].path[1];
        _this.formData.district_id=checkedNode[0].path[2];
      },
      // 关闭
      handleClose() {
        this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let params=this.formData;
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');

        this.$axios.shopSave(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");
            this.handleClose();
          }else{
            this.$message.error("商户号已经绑定，请使用其他商户号");

          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getPosBrandList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findPosBrandList(param).then(res=>{
          if(res.code == 200){
            this.posBrandList = res.data

          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      },
      memberRemoteMethod(query){
        if (query !== '') {
          this.memberLoading = true;
          let param={
            keyword:query,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.posMemberListP(param).then(res=>{
            if(res.code == 200){
              this.memberStates = res.data.data;
            }
          }).catch(error=>{
              console.log(error);
          })
          setTimeout(() => {
            this.memberLoading = false;
            this.memberList = this.memberSet.filter(item => { // 这里的this.list，换为this.applicantSet
              return item.name;
            });
          }, 1000);
        } else {
          this.memberList = [];
        }
      },
    },
    computed: {
      memberSet() {
        return this.memberStates.map(item => {
          return {id: `${item.id}`, name: `${item.merchant_name}`};
        });
      },
    },
    // 监听
    watch: {
     async visible(val) {
        this.localVisible=val;
        console.log('----val---55555777778888-',val)
        if (val) {
         if(this.formData.member){
           console.log('----merchant----',this.formData.member.merchant_name)
           await this.memberRemoteMethod(this.formData.member.merchant_name);
           //this.formData.pos_member_id=this.formData.member.id+'';
           console.log('----id----',this.formData.member.id)

          this.$refs['cascaderAddr'].inputValue=(this.formData.province?this.formData.province.region_name:'')+'-'+(this.formData.city?this.formData.city.region_name:'')+'-'+(this.formData.district?this.formData.district.region_name:'');



         }
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
